module.exports = __webpack_public_path__ + "static/fonts/gothammedium.1ae8dbf.ttf";